// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#store_list[data-v-125197ba] {\n  border: 1px solid #4A4A4A;\n  border-radius: 3px;\n  width: 100%;\n  min-height: 350px;\n  max-height: 350px;\n  overflow: auto;\n}\n#store_list[data-v-125197ba]::-webkit-scrollbar {\n  width: 3px;\n}\n#store_list[data-v-125197ba]::-webkit-scrollbar-thumb {\n  background-color: white;\n}\n#store_list[data-v-125197ba]::-webkit-scrollbar-track {\n  background-color: #4A4A4A;\n}", ""]);
// Exports
module.exports = exports;
